import { render } from "./subItemModel.vue?vue&type=template&id=2ef2aa54"
import script from "./subItemModel.vue?vue&type=script&lang=js"
export * from "./subItemModel.vue?vue&type=script&lang=js"

import "./subItemModel.vue?vue&type=style&index=0&id=2ef2aa54&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__